import $ from 'jquery';
import Foundation from 'foundation-sites'; // eslint-disable-line

// assets
import initAnalytics from 'public/assets/js/analytics';
import 'public/assets/js/analytics/utilities';
import 'public/assets/js/lib/jquery.throttle.js';

// helpers
import { AnalyticsBlockList } from 'src/lib/constants';

/**
 *
 * @param {Object} props
 * @param {string} props.route
 */
const initApp = ({ route }) => {
  // init jquery for marketo scripts
  window.$ = $;
  window.jQuery = $;

  // TODO:
  // Reconsider how we're handling analytics, thus far this does not seem
  // that it needs to be refactored since it's not using jQuery
  if (!AnalyticsBlockList.has(route)) {
    initAnalytics();
  }

  // init foundation
  // TODO: https://jira.plaid.com/browse/SITE-1729
  $(document).foundation();
};

export default initApp;
